import { Dictionary } from "flow/api/types";
import location from "flow/wrappers/location";

function getUrl() {
    return location.getUrl().toString();
}

function getBaseUrl() {
    const url = location.getUrl();
    url.search = "";
    url.hash = "";
    let urlString = url.toString();

    const lastDot = urlString.lastIndexOf(".");
    const lastSlash = urlString.lastIndexOf("/");

    // Remove filename part if needed
    if (lastDot > 0 && lastSlash > 0 && lastDot > lastSlash) {
        urlString = urlString.substring(0, lastSlash + 1);
    }

    if (!urlString.endsWith("/")) {
        urlString += "/";
    }
    return urlString;
}

function getFragment() {
    let fragment = location.getUrl().hash;
    if (fragment.indexOf("#") === 0) {
        fragment = fragment.slice(1);
    }
    return fragment;
}

function replaceFragment(fragment: string) {
    const url = location.getUrl();
    url.hash = fragment;
    return url.toString();
}

function isStringArray(val: string | string[]): val is string[] {
    return Array.isArray(val);
}

function getDataMap() {
    const urlSearchParams = location.getUrl().searchParams;
    const dataMap: Dictionary<string | string[]> = {};
    // Map object. If there are multiple values on one key, make an array for those.
    urlSearchParams.forEach((value, key) => {
        if (dataMap.hasOwnProperty(key)) {
            const currentValue = dataMap[key];
            if (isStringArray(currentValue)) {
                currentValue.push(value);
            } else {
                dataMap[key] = [currentValue, value];
            }
        } else {
            dataMap[key] = value;
        }
    });
    return dataMap;
}

export default {
    getUrl: getUrl,
    getBaseUrl: getBaseUrl,
    getFragment: getFragment,
    replaceFragment: replaceFragment,
    getDataMap: getDataMap
};
